import { makeStyles } from "tss-react/mui"
import { Alert, AlertTitle, Stack, Typography } from "@mui/material"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../../modules/localization/useDateTime"
import { StandardDialog } from "../../../../dialogs/StandardDialog"
import { Message } from "../../../createOrderTypes"

import { mapMessagePriorityToAlertSeverity } from "./helpers"

const useStyles = makeStyles()((_theme) => ({
    container: {
        padding: "1rem 2rem 3rem",
    },
}))

type MessagesDialogProps = Readonly<{
    messages: Message[]
    onClose: () => void
}>

export function MessagesDialog({ messages, onClose }: MessagesDialogProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    return (
        <LocalizedStrict id="create-order-drawer-messages-dialog-title" attrs={{ dialogTitle: true }}>
            <StandardDialog
                dialogTitle="Messages from the merchant"
                open
                onClose={onClose}
                maxWidthProp="md"
                scroll="body"
            >
                <Stack gap="1rem" className={classes.container}>
                    {messages.map((msg) => (
                        <Alert key={msg.id} severity={mapMessagePriorityToAlertSeverity(msg.priority)}>
                            <AlertTitle>{msg.text}</AlertTitle>
                            <Typography>
                                {dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(msg.publishDate))}
                            </Typography>
                        </Alert>
                    ))}
                </Stack>
            </StandardDialog>
        </LocalizedStrict>
    )
}
